import { api } from "@/services/api";
import { LoginResponse } from "@/types";

export class AuthRepository {
  async login(phoneNumber: string, otp: string): Promise<LoginResponse> {
    const response = await api.post("/v1/users/login", { phoneNumber, otp });

    return response.data;
  }
}
